import {
    Navigate,
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {EditPage} from "./pages/EditPage.tsx";

import {AddPage as AddBankAccountPage} from '../bank-accounts/pages/AddPage';
import {EditPage as EditBankAccountPage} from '../bank-accounts/pages/EditPage.tsx';
import {AddPage as AddCardPage} from '../cards/pages/AddPage';
import {EditPage as EditCardPage} from '../cards/pages/EditPage.tsx';
import {useVerifiedPermissions} from "../../hooks/useVerifiedPermissions.ts";
import {rbacActions} from "../../config/rbac/actions.ts";
import {
    loadStripe,
    StripeElementsOptions
} from "@stripe/stripe-js";
import config from "../../config";
import {Elements} from "@stripe/react-stripe-js";

const stripePromise = loadStripe(config.stripe.publishableKey);

export const CustomersLayout = () => {

    const {allowedActions} = useVerifiedPermissions()

    const options = {} as StripeElementsOptions;


    return (
        <Routes>
            <Route
                path='/'
                element={
                    allowedActions.includes(rbacActions.ListCustomers) ? (
                        <IndexPage/>
                    ) : (
                        <Navigate to='/'/>
                    )
                }
            />
            <Route
                path=':id'
                element={
                    allowedActions.includes(rbacActions.GetCustomer) ? (
                        <EditPage/>
                    ) : (
                        <Navigate to='/customers'/>
                    )
                }

            >
            </Route>


            <Route
                path=':id/bank-accounts/add'
                element={
                    allowedActions.includes(rbacActions.CreateBankAccount) ? (
                        <Elements stripe={stripePromise} options={options}>
                            <AddBankAccountPage/>
                        </Elements>
                    ) : (
                        <Navigate to='/customers/:id'/>
                    )
                }
            />

            <Route
                path=':id/bank-accounts/:bankAccountId'
                element={
                    allowedActions.includes(rbacActions.GetBankAccount) ? (
                        <Elements stripe={stripePromise} options={options}>
                            <EditBankAccountPage/>
                        </Elements>
                    ) : (
                        <Navigate to='/customers/:id'/>
                    )
                }
            />

            <Route
                path=':id/cards/add'
                element={
                    allowedActions.includes(rbacActions.CreateCard) ? (
                        <Elements stripe={stripePromise} options={options}>
                            <AddCardPage/>
                        </Elements>
                    ) : (
                        <Navigate to='/customers/:id'/>
                    )
                }
            />

            <Route
                path=':id/cards/:cardId'
                element={
                    allowedActions.includes(rbacActions.GetCard) ? (
                        <Elements stripe={stripePromise} options={options}>
                            <EditCardPage/>
                        </Elements>
                    ) : (
                        <Navigate to='/customers/:id'/>
                    )
                }
            />

        </Routes>
    );
};
